import React from 'react'
import { Routes , Route} from 'react-router-dom'
import Layouts from './../Layouts/Layouts';
import Apropos from '../Pages/APropos/Apropos';
import Home from '../Pages/Home/Home';
import ShopWidePage from "../Pages/Shop/ShopWide";
import ShoppingCart from "../Pages/Shop/ShoppingCart";
import SingleStory from "../Pages/Story/SingleStory";
import RightSidebar from "../Pages/Shop/RightSidebar";
import OnlyCategoriesPage from "../Pages/Shop/OnlyCategories";
import Checkout from "../Pages/Shop/Checkout";
import LoginRegister from "../Pages/Registre/LoginRegister";
import Contact from '../Pages/Contact/Contact';
import ComptClient from '../App/Pages/ComptClient'
import Category from '../Pages/Category/Category';
import StoryByCategory from '../Pages/Story/StoryByCategory';
import AllStories from '../Pages/Story/AllStories';
import LayoutCustomer from '../App/components/LayoutCustomer';
import Dashboard from '../App/Pages/Dashboard';
import ProtectedRoute from '../App/components/ProtectedRoute';
import Orders from '../App/Pages/Orders/Orders';
import Condition from '../Pages/Condition/condition';
import OrderDetails from '../App/Pages/Orders/OrderDetails';
import Register from '../Pages/Registre/Register';



export default function Routeur () {
  return (
        <Routes>
            <Route path='' element={<Layouts/>}>
                <Route path='/' element={<Home/>}/>
                <Route path='/apropos' element={<Apropos/>}/>
                <Route path='/contact' element={<Contact/>}/>
                <Route path='/product' element={<Category/>}/>
                <Route path='/product-by-category/:id' element={<StoryByCategory/>}/>
                {/* <Route path="all_product" element={<AllStories />} />
                 */}
                 <Route path="/single-product/:id" element={<SingleStory />} />
                
                    <Route path="shop-wide" element={<ShopWidePage />} />
                    <Route path="right-sidebar" element={<RightSidebar />} />
                    <Route
                      path="only-categories"
                      element={<OnlyCategoriesPage />}
                    />{" "}
                    <Route
                      path="shopping-cart"
                      element={
                        <ShoppingCart style={{ "--base-color": "#0038e3" }} />
                      }
                    />
                    <Route path="checkout" element={<Checkout />} />
                    <Route path="login-register" element={<LoginRegister />} />
                    <Route path="register" element={<Register />} />
                    <Route path="condition/:id" element={<Condition />} />
            </Route>
                    
      {/* Private routes with LayoutCustomer */}
      <Route element={<ProtectedRoute />}>
        <Route element={<LayoutCustomer />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/account" element={<ComptClient />} />
          <Route path="/order-details-client/:id" element={<OrderDetails />} />
      </Route>
      </Route>
        </Routes>
  )
}
/* contact-classic
pricing-packages
who-we-are */